import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { ARTIFACTS } from './Wildlife';

function Artifact({ pos }) {
  const grp = useRef();
  const ring = useRef();
  useFrame((state) => {
    const t = state.clock.elapsedTime;
    if (grp.current) grp.current.position.y = pos.y + 1.6 + Math.sin(t * 1.5 + pos.x) * 0.4;
    if (grp.current) grp.current.rotation.y = t * 0.6;
    if (ring.current) ring.current.rotation.z = -t;
  });
  return (
    <group ref={grp} position={[pos.x, pos.y + 1.6, pos.z]}>
      <mesh>
        <icosahedronGeometry args={[1.1, 0]} />
        <meshStandardMaterial color="#fff3c4" emissive="#D4AF37" emissiveIntensity={1.6} flatShading />
      </mesh>
      <mesh ref={ring} rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[2, 0.08, 8, 32]} />
        <meshStandardMaterial color="#D4AF37" emissive="#D4AF37" emissiveIntensity={1.2} />
      </mesh>
      <pointLight color="#ffd970" distance={22} intensity={1.4} />
    </group>
  );
}

// Glowing 'contested artifacts' drifting in the river — piranhas swarm these.
export default function Artifacts() {
  return (
    <group>
      {ARTIFACTS.map((p, i) => (
        <Artifact key={i} pos={p} />
      ))}
    </group>
  );
}
